import { Alert, Box, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Link as RouterLink, Navigate, Outlet } from "react-router-dom";

export default function PrivateOutlet() {
  const token = Cookies.get("token");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!token) {
      setState("unauthorized");
      return undefined;
    }
    let active = true;
    const controller = new AbortController();
    setState("checking");
    axios.get(`${process.env.React_APP_BACKEND_URL}/api/profile`, {
      headers: { Authorization: `Bearer ${token}` },
      signal: controller.signal,
      timeout: 12000,
    }).then(() => {
      if (active) setState("authorized");
    }).catch((error) => {
      if (!active || error?.code === "ERR_CANCELED") return;
      const status = error?.response?.status;
      const blocked = status === 403 && error?.response?.data?.error === "ACCOUNT_BLOCKED";
      // The global interceptor in index.js handles actual blocked accounts.
      // A missing tender, server failure, or network error must not be treated as logout.
      if (blocked) return;
      if (status === 401 || status === 419) {
        setState("unauthorized");
      } else {
        setState("error");
      }
    });
    return () => {
      active = false;
      controller.abort();
    };
  }, [token]);

  if (state === "unauthorized") return <Navigate to="/signin" replace />;
  if (state === "authorized") return <Outlet />;
  if (state === "error") {
    return (
      <Box dir="rtl" sx={{ maxWidth: 520, mx: "auto", my: 6, px: 2, textAlign: "center" }}>
        <Alert severity="warning" sx={{ mb: 2 }}>לא ניתן לטעון את הנתונים כרגע. ההתחברות שלך לא נמחקה.</Alert>
        <Button component={RouterLink} to="/" variant="contained">חזרה לדף הבית</Button>
      </Box>
    );
  }
  return <Box sx={{ display: "flex", justifyContent: "center", py: 7 }}><CircularProgress aria-label="בודקים התחברות" /></Box>;
}
